<script setup>
import { useTranslation, } from '@/assets/js/src/util/composables'
const { t, } = useTranslation()
</script>

<template>
    <div>
        <h2 class="mt-5 mb-2">
            {{ t('async.webmasters.privacy.heading') }}
        </h2>
        <div v-html="t('async.webmasters.privacy.text')"></div>
    </div>
</template>
